import { ColDef } from 'ag-grid-community';
import { buildColDefFromColumnDefinition } from '@instinet-analytics/semantic-ui-components';
import { IndigoAppContextType } from 'app/AppContext';
import {
    expertiseColumnDefinitions,
    ExpertiseColumn,
} from 'widgets/expertise/ExpertiseColumnDefinitions';

const expertiseNighthawkColumns: ExpertiseColumn[] = [
    'dateTime',
    'orderId',
    'venueName',
    'size',
    'price',
    'symbol',
    'side',
    'eventType',
    'eventReason',
    'orderLevel',
    'ordType',
    'pegType',
    'tIF',
    'minFill',
    'tactic',
    'currency',
    'residual',
    'startTime',
    'endTime',
    'style',
    'maxPartRate',
    'fadeLogic',
    'footprintMinimization',
    'walkupProtection',
    'lastTradePrice',
    'bidPrice',
    'askPrice',
    'otherSymbol',
    'otherBidPrice',
    'otherAskPrice',
    'fxRate',
];

export const columnDefs: (context: IndigoAppContextType) => ColDef[] = (
    context
) =>
    expertiseNighthawkColumns.map((id) => {
        const columnDefinition = expertiseColumnDefinitions[id];
        return buildColDefFromColumnDefinition(context, id, columnDefinition);
    });
